export default __webpack_public_path__ + "static/media/zarzadzanie-klientami-3.89efa879.png";